<template>
  <div>
    <div class="alert alert-danger" role="alert" v-if="stripeErrorMessage">
      <h4 class="alert-heading">
        {{ stripeErrorMessage }}
      </h4>
    </div>

    <div class="payment-container">
      <div>
        <div class="payment-info visible">
          <fieldset>
            <label>
              <span> {{ translate('payment.cardholder') }}</span>
              <input name="cardholder_name"
                     class="field"
                     placeholder="Jenny Rosen"
                     v-model="cardForm.cardholder_name"
                     required>
            </label>
            <label>
              <span>{{ translate('payment.card') }}</span>
              <div id="card-element" class="field"></div>
            </label>
          </fieldset>
        </div>

        <button class="btn btn-primary btn-block card-shadow mt-2"
                @click.prevent="getStripeTokenAndPay"
                :disabled="createPaymentForm.busy || !terms"
                type="submit">
          {{ translate('payment.pay') }} <i class="fas fa-euro-sign"></i> {{ newAmount ? newAmount.amount : amount }}
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import {loadStripe} from '@stripe/stripe-js';

export default {
  mixins: [require('../../../resources/js/mixin')],

  props: [
    'coupon',
    'stripePublicKey',
    'paymentOption',
    'amount',
    'newAmount',
    'terms'
  ],

  data () {
    return {
      cardElement: null,

      cardForm: new AppForm({
        cardholder_name: '',
      }),

      createPaymentForm: new AppForm({
        _token: App.csrfToken,
        stripe_token: null,
        stripe_token_meta: null,
        payment_option: 'credit-card',
        source: null,
      }),

      stripe: {},
      stripeSource: {},
      stripeCard: {},
      stripeCardLoaded: false,
      stripeErrorMessage: null,
    };
  },

  created () {
    (async () => {
      this.stripe = await loadStripe(this.stripePublicKey);
      this.createStripeCard();
    })();
  },

  watch: {
    newAmount (newValue) {
      this.newAmount = newValue;
      if (!newValue) {
        if (this.createPaymentForm.coupon) {
          delete this.createPaymentForm.coupon;
        }
      }
    },

    paymentOption (option) {
      this.$nextTick(() => {
        this.createStripeCard();
      });
    },
  },

  methods: {
    getStripeTokenAndPay () {
      let self = this;

      if (this.newAmount) {
        this.createPaymentForm.coupon = this.newAmount.coupon;
      }

      this.createPaymentForm.startProcessing();

      this.getStripeToken(function (response) {
        if (response.error) {
          self.createPaymentForm.busy = false;
        } else {
          self.createPaymentForm.stripe_token = response.token.id;
          self.createPaymentForm.stripe_token_meta = response.token;
          self.createPaymentForm.payment_option = 'credit-card';
          self.createPayment();
        }
      });
    },

    getStripeToken (callback) {
      this.cardForm.errors.forget();

      // Here we will build out the payload to send to Stripe to obtain a card token so
      // we can make a payment after booking is created. We will build out this data that has
      // this credit card number, CVC, etc. and exchange it for a secure token ID.
      const payload = {
        name: this.cardForm.cardholder_name,
      };

      // Once we have the Stripe payload we'll send it off to Stripe and obtain a token
      // which we will send to the server to update this payment method. If there is
      // an error we will display that back out to the user for their information.
      this.stripe.createToken(this.stripeCard, payload).then(response => {
        if (response.error) {
          this.cardForm.errors.set({
            card: [
              response.error.message
            ]
          });
        }

        callback(response);
      });
    },

    createPayment () {
      let self = this;

      App.post('/api/payments', this.createPaymentForm)
        .then((response) => {
          window.location = response.redirect_url;
        })
        .catch((error) => {
          self.stripeErrorMessage = error.message;
        });
    },

    createStripeCard () {
      if (!this.stripeCardLoaded) {
        this.stripeCard = this.stripe.elements().create('card', {
          style: {
            base: {
              color: '#263c61',
            }
          },
          hidePostalCode: true,
          iconStyle: 'solid',
        });
        this.stripeCard.mount('#card-element');

        this.stripeCard.on('change', (event) => {
          if (event.error) {
            this.stripeErrorMessage = event.error.message;
          } else {
            this.stripeErrorMessage = null;
          }
        });

        this.stripeCardLoaded = true;
      }
    },
  }
};
</script>

<style scoped>
.stripe-card-container {
    border: 1px solid grey;
    border-radius: 2px;
    margin: auto;
    width: 100%;
    padding: 2px 2px;
}
</style>
